import regeneratorRuntime from "regenerator-runtime";

const BlockedCountriesComponent = {
  mounted(){
    console.log("BlockedCountriesComponent mounted")
    this.getComponents().then((Tagify) => {
      this.pushEventTo("#update_blocked_countries_form", "get_countries", {"roro": "qwe"}, (reply, _ref) => {
        let tagify = new Tagify(this.el, {
          tagTextProp: "key",
          enforceWhitelist: true,
          skipInvalid: true,
          dropdown: {
            closeOnSelect: true,
            enabled: 0,
            searchKeys: ['key', 'value'],
            mapValueTo: "key"
          },
          whitelist: reply.countries
        })
      })
    })
  },
  getComponents: async function () {
    const {default: Tagify} = await import('@yaireo/tagify')
    await import("@yaireo/tagify/dist/tagify.css")
    return Tagify;
  },
  disconnected() { console.log('Tagify disconnected') },
  reconnected()  { console.log('Tagify reconnected') },
  updated()      { console.log('Tagify updated') },
  destroyed()    { console.log('Tagify destroyed') }
}

export default { BlockedCountries: BlockedCountriesComponent };
